import React from "react";
import { Alert, Button } from "antd";

export default function LogListError({ error, retry }) {
  return error ? (
    <Alert
      type="error"
      showIcon
      message={error}
      action={<Button onClick={retry}>Retry</Button>}
      style={{ marginBottom: 16 }}
    />
  ) : null;
}
